import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  DbDeliverableType,
  useLazyGetApiProgramsAvailableDeliverableTypesQuery,
} from '../../app/athenaApiGen';

type TProgramAvailableDeliverableTypesFilterProps = {
  handleChange: (id?: string | null) => void;
  programDeliverableTypeId: string;
  required?: boolean;
};

const ProgramAvailableDeliverableTypesFilter = (
  props: TProgramAvailableDeliverableTypesFilterProps,
) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<DbDeliverableType[]>([]);
  const [queryDeliverableProgramTypes, { isFetching: isLoading }] =
    useLazyGetApiProgramsAvailableDeliverableTypesQuery();

  const handleOpen = async () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    (async () => {
      try {
        const programs = await queryDeliverableProgramTypes().unwrap();
        setOptions(programs);
      } catch (err) {
        console.log(err);
      }
    })();
  }, [queryDeliverableProgramTypes]);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Autocomplete
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        isOptionEqualToValue={(option, value) => option?.title === value?.title}
        getOptionLabel={(option) => option?.title ?? ''}
        options={options}
        loading={isLoading}
        onChange={(_, newValue) => {
          props.handleChange(newValue ? newValue?.deliverableTypeId : null);
        }}
        value={
          options.find(
            (opt) => opt.deliverableTypeId === props.programDeliverableTypeId,
          ) || null
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Deliverable Type"
            required={props.required}
            size="small"
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {isLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default ProgramAvailableDeliverableTypesFilter;
